import { call, put, takeLatest } from 'redux-saga/effects'
import { defineTypes } from '../helpers'
import SessionEndpoint from '../persistence/SessionEndpoint'
import { reduxFetch } from '../http/reduxFetch'
import { push } from 'react-router-redux'

const sessionTypes = { NO_SESSION: 'SESSION/NO_SESSION', GET_KEY: 'SESSION/GET_KEY', SET_KEY: 'SESSION/SET_KEY', CHECK_SESSION: 'SESSION/CHECK', REQUEST: 'SESSION/REQUEST', SUCCESS: 'SESSION/SUCCESS', FAILURE: 'SESSION/FAILURE', DESTROY_SESSION: 'SESSION/DESTROY' };
const sessionStore = { ...defineTypes('SESSION_STORE') }
export const refreshSessionStore = { ...defineTypes('REFRESH_SESSION_STORE') }

export const initialState = {
  token: undefined,
  loading: false,
  loaded: false,
  errors: {}
}

export const actions = {
  login (email, password) {
    return { type: sessionTypes.REQUEST, email, password }
  },

  destroySession () {
    return { type: sessionTypes.DESTROY_SESSION }
  },

  setSessionKey() {
    return { type: sessionStore.REQUEST }
  },

  refreshSession(key) {
    return { type: refreshSessionStore.REQUEST, key }
  },

  setKeyToken(key, token) {
    return { type: 'SET_SESSION', key: key, token: token }
  },
  setToken(token) {
    return { type: 'SET_TOKEN', token: token }
  },
  checkForSessionKey() {
    return { type: sessionTypes.CHECK_SESSION };
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case sessionTypes.REQUEST:
      return { ...state, started: true, loading: true }
    case sessionTypes.DESTROY_SESSION:
      sessionStorage.setItem('session', 'logged out')
      return { ...state, token: undefined, loading: false }
    case sessionTypes.FAILURE:
      return { ...state, loading: false, errors: action.error }
    case sessionTypes.SUCCESS:
      return { ...state, token: action.token, loading: false, started: false }
    case sessionStore.REQUEST:
      return { ...state, started: true, loading: true }
    case sessionStore.DESTROY:
      return { ...state, token: undefined, loading: false }
    case sessionStore.FAILURE:
      return { ...state, loading: false }
    case sessionStore.SUCCESS:
      return { ...state, key: action.key, loading: false, started: false }
    case refreshSessionStore.REQUEST:
      return { ...state, started: true, loading: true }
    case refreshSessionStore.DESTROY:
      return { ...state, token: undefined, loading: false }
    case refreshSessionStore.FAILURE:
      return { ...state, loading: false }
    case refreshSessionStore.SUCCESS:
      return { ...state, key: action.key, token: action.token, loading: false, started: false }
    case 'SET_SESSION':
      return { ...state, key: action.key, token: action.token }
    case 'SET_TOKEN':
      return { ...state, token: action.token }
    case sessionTypes.CHECK_SESSION:
      return { ...state, session_loading: true }
    case sessionTypes.NO_SESSION:
      return { ...state, session_loading: false }
    default:
      return state
  }
}

export const selectors = {
  token: ({ session }) => session.token,
  errors: ({ session }) => session.errors,
  parsedToken: (store) => selectors.token && selectors.token(store) && parseJwt(selectors.token(store)),
  role: (store) => selectors.parsedToken && selectors.parsedToken(store) && selectors.parsedToken(store)['rol'] || 'non_user',
  user_id: (store) => selectors.parsedToken && selectors.parsedToken(store) && selectors.parsedToken(store)['sub'],
  email: (store) => selectors.parsedToken && selectors.parsedToken(store) && selectors.parsedToken(store)['eml']
}

function parseJwt (token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
};

function getSessionKey() {
  let session_key = sessionStorage.getItem('session')
  return session_key
}

function setSessionKey(key) {
  let session_key = sessionStorage.setItem('session', key)
}

function removeSessionKey() {
  sessionStorage.removeItem('session')
}

export function * sessionSaga ({ email, password }) {
  try {
    const response = yield call(reduxFetch, SessionEndpoint.create({ email, password }))
    if (response['jwt']) {
      yield put({ type: sessionTypes.SUCCESS, token: response.jwt })
      yield put({ type: sessionStore.REQUEST })
      yield put(push('/reservations'))
    } else {
      yield put({ type: sessionTypes.FAILURE, error: response['errors'] })
    }
  } catch (error) {
    yield put({ type: sessionTypes.SUCCESS, error })
  }
}

export function* refreshSessionSaga({ key }){
  try {
    const response = yield call(reduxFetch, SessionEndpoint.refreshToken(key))
    yield call(refreshSuccess, response.jwt, response.body)
    sessionStorage.setItem('session', response.key)
  } catch (error) {
    yield put({ type: refreshSessionStore.FAILURE })
    yield put(push('/'))
  }
}

export function* refreshSuccess( token, key) {
  yield put({ type: refreshSessionStore.SUCCESS, token: token, key: key })
}

export function* sessionStoreSaga(){
  try {
    const response = yield call(reduxFetch, SessionEndpoint.key())
    yield put({ type: sessionStore.SUCCESS, key: response.key })
    sessionStorage.setItem('session', response.key)
  } catch (error) {
    yield put({ type: sessionStore.FAILURE })
  }
}

export function * checkSession() {
    try {
      const key = yield call(getSessionKey)
      if (key !== null) {
        yield put({ type: refreshSessionStore.REQUEST, key: key })
      } else {
        yield put({ type: sessionTypes.NO_SESSION })
      }
    } catch (error) {
      yield put({ type: sessionTypes.NO_SESSION })
      yield put({ type: refreshSessionStore.FAILURE, errors: error })
    }
}


export function * getKey() {
  try {
    const response = yield call(fetch, SessionEndpoint.key())
    if ( response['key'] ) {
      yield put({ type: sessionTypes.SET_KEY, key: response['key'] })
      yield call(setSessionKey, response.key)
    } else {
      yield put({ type: sessionTypes.NO_SESSION })
      yield put({ type: sessionTypes.FAILURE, errors: response['error'] })
    }
  } catch(error) {
      yield put({ type: sessionTypes.NO_SESSION })
      yield put({ type: sessionTypes.FAILURE, errors: error })
  }
}

export function * logout() {
    try {
      yield call(removeSessionKey)
      const key = yield call(getSessionKey)
      if (key === null) {
        yield put({ type: sessionTypes.SUCCESS, key: null, token: null })
      } else {
        yield put({ type: sessionTypes.FAILURE, key: null, token: null })
      }
    } catch (error) {
      yield put({ type: sessionTypes.FAILURE, key: null, token: null })
    }
}


export function * rootSaga () {
  yield takeLatest(sessionTypes.REQUEST, sessionSaga)
  yield takeLatest(sessionStore.REQUEST, sessionStoreSaga)
  yield takeLatest(refreshSessionStore.REQUEST, refreshSessionSaga)
  yield takeLatest(sessionTypes.CHECK_SESSION, checkSession)
  yield takeLatest(sessionTypes.GET_KEY, getKey)
  yield takeLatest(sessionTypes.DESTROY_SESSION, logout)
}



// WEBPACK FOOTER //
// ./src/sagas/session.js